import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { useFieldArray } from 'react-hook-form'

import AddIcon from '@mui/icons-material/Add'
import DeleteIcon from '@mui/icons-material/Delete'

import FormInput from '../inputFields/FormInput'
import { FlexColumn, CenteredRowContainer, FlexRow } from '../styles/Containers'
import { SecondaryButton, IconButton } from '../common/Button'

const StyledFlexRow = styled(FlexRow)`
  flex-wrap: wrap;
  align-items: flex-start;

  @media (max-width: 800px) {
    align-items: center;
  }
`

const InputsWrapper = styled.div`
  display: flex;
  flex: 1;
  min-width: 0;
  gap: 20px;

  @media (max-width: 800px) {
    flex-wrap: wrap;
  }
`

const DeleteButtonContainer = styled.div`
  display: flex;
  align-items: flex-start;
  margin-left: 15px;
  flex-shrink: 0;
  padding-top: 30px;

  @media (max-width: 727px) {
    align-items: center;
    padding-top: 0;
  }
`

function InternalSummaryForm({ loading = false }) {
  const { fields, append, remove } = useFieldArray({ name: 'internalSummary' })

  return (
    <FlexColumn>
      {fields.map((field, index) => (
        <StyledFlexRow key={field.id}>
          <InputsWrapper>
            <FormInput
              required={true}
              id={`internalSummary.${index}.label`}
              label="Label"
              disabled={loading}
              basis="50%"
              minwidth="60px"
              value={field.label}
              multiline
            />
            <FormInput
              required={true}
              id={`internalSummary.${index}.value`}
              label="Value"
              disabled={loading}
              basis="50%"
              minwidth="60px"
              value={field.value}
              multiline
            />
          </InputsWrapper>
          <DeleteButtonContainer>
            <IconButton onClick={() => remove(index)} aria-label="Delete item" disabled={loading}>
              <DeleteIcon />
            </IconButton>
          </DeleteButtonContainer>
        </StyledFlexRow>
      ))}
      <CenteredRowContainer>
        <SecondaryButton onClick={() => append({ label: '', value: '' })} disabled={loading}>
          <AddIcon />
          Add Item
        </SecondaryButton>
      </CenteredRowContainer>
    </FlexColumn>
  )
}

InternalSummaryForm.propTypes = {
  loading: PropTypes.bool
}

export default InternalSummaryForm
